import { Stack, Typography, Box } from '@mui/material'
import { DataGrid } from 'Components/LifeDataGrid'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import urls from 'utils/urls'
import { makeGetRequest, makePostRequest } from 'utils/api'
import DoneOperationForm from '../DoneOperationForm'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'

function ListOperationsRealiser({
  fetchOperations,
  setDoneF,
  setEventF,
  setEventViewF,
  operations,
  setSelectedRows,
}) {
  const siteUser = useSelector((store) => store.user)

  let navigate = useNavigate()
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }
  const columns = [
    {
      field: 'EstimatedDate',
      headerName: 'Date estimé',
      width: 140,
      editable: false,
      valueGetter: (params) =>
        `${
          params.row.ScheduleDate
            ? convertToUserDateFormate(siteUser.user, params.row.ScheduleDate)
            : convertToUserDateFormate(siteUser.user, params.row.EstimatedDate)
        }`,
    },
    {
      field: 'OperationType',
      headerName: 'Type',
      width: 130,
      editable: false,
    },
    {
      field: 'MaintenanceOperation',
      headerName: 'Désignation',
      width: 350,
      editable: false,
    },
    {
      field: 'EstimatedTime',
      headerName: 'Temps',
      width: 130,
      editable: false,
    },
    {
      field: 'EstimatedCost',
      headerName: 'Coût estimé',
      width: 100,
      editable: false,
      valueGetter: (params) => `${params.row.EstimatedCost ? params.row.EstimatedCost : ''} €`,
    },
    {
      field: 'Done',
      headerName: 'Fait',
      width: 80,
      editable: false,
      renderCell: (params) => {
        return (
          <div onClick={() => setDoneF(params.row.id)}>
            <input type="checkbox" name="" value="" />
          </div>
        )
      },
    },
    {
      field: 'Schedule',
      headerName: 'Planifié',
      width: 100,
      editable: false,
      renderCell: (params) => {
        let color = 'red'
        if (params.row.Schedule === 'Oui') {
          color = 'green'
        }
        return (
          <>
            {params.row.Event_obj ? (
              <Box
                onClick={() => {
                  setEventViewF(params.row.Event)
                }}
                sx={{ color: color }}
              >
                {params.row.Schedule}
              </Box>
            ) : (
              <Box
                onClick={() => {
                  setEventF(params.row)
                }}
                sx={{ color: color }}
              >
                {params.row.Schedule}
              </Box>
            )}
          </>
        )
      },
    },
  ]

  return (
    <div
      style={{
        height: 500,
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          color: 'black',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        Opérations à réaliser cette année ({operations.count})
      </Typography>

      <DataGrid
        sx={{
          '.MuiDataGrid-footerContainer': {
            background: 'white',
          },
        }}
        rows={operations.results ? operations.results : []}
        columns={columns}
        pageSize={rows}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        checkboxSelection
        disableSelectionOnClick
      />
    </div>
  )
}
export default ListOperationsRealiser
